import { useEffect, useRef } from 'react';
var Step2Video = function Step2Video() {
  var videoRef = useRef(null);
  var options = {
    rootMargin: '-200px 0px -100px 0px',
    threshold: 1.0
  };
  var handlePlay = function handlePlay(entries, observer) {
    // const em = document.getElementById('video2');

    entries.forEach(function (entry) {
      if (entry.isIntersecting && videoRef && videoRef.current) {
        videoRef.current.play();
        videoRef.current.defaultMuted = true;
        videoRef.current.muted = true;
        $('#video2').css({
          opacity: 1
        });
      } else {
        var _videoRef$current;
        videoRef === null || videoRef === void 0 ? void 0 : (_videoRef$current = videoRef.current) === null || _videoRef$current === void 0 ? void 0 : _videoRef$current.pause();
        $('#video2').css({
          opacity: 0
        });
      }
    });
  };
  useEffect(function () {
    var observer = new IntersectionObserver(handlePlay, options);
    if (videoRef) observer.observe(videoRef.current);
    return function () {
      if (document.getElementById('video2')) observer === null || observer === void 0 ? void 0 : observer.unobserve(videoRef === null || videoRef === void 0 ? void 0 : videoRef.current);
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "ht-step-2__video"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/step2/video@3x.png",
    className: "ht-step-2__video-img"
  }), /*#__PURE__*/React.createElement("video", {
    id: "video2",
    ref: videoRef,
    muted: true,
    playsInline: true
    // controls
    ,
    src: "/public/videos/step-2.mp4"
    // src='https://archive.org/download/BigBuckBunny_124/Content/big_buck_bunny_720p_surround.mp4'
  }));
};
export default Step2Video;